import { render, staticRenderFns } from "./hamburger.vue?vue&type=template&id=523ced43&scoped=true&"
import script from "./hamburger.vue?vue&type=script&lang=js&"
export * from "./hamburger.vue?vue&type=script&lang=js&"
import style0 from "./hamburger.vue?vue&type=style&index=0&id=523ced43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523ced43",
  null
  
)

export default component.exports